import computeClassName from '../../../utils/computeClassName';
import CCLoaderCircleSmall from '../../libs/CiscoCore/Loader/Circle/Small';
import CCLoaderCircleMedium from '../../libs/CiscoCore/Loader/Circle/Medium';
import CCLoaderCircleLarge from '../../libs/CiscoCore/Loader/Circle/Large';
import CCLoaderCircleExtraLarge from '../../libs/CiscoCore/Loader/Circle/ExtraLarge';
import {getValidProp} from "../../../utils/cleanValidateStringPropValue";
import appConstants from "../../../constants";

const SIZE_SMALL = 'small';
const SIZE_MEDIUM = 'medium';
const SIZE_LARGE = 'large';
const SIZE_EXTRALARGE = 'extralarge';

const constants = Object.freeze({
  COMPONENT_NAME: 'ProcessingIndicator',
  CLASSNAME_BASE: 'inline-flex flex-row items-center justify-center align-middle',
  SIZES: [
    SIZE_SMALL,
    SIZE_MEDIUM,
    SIZE_LARGE,
    SIZE_EXTRALARGE
  ],
  SIZE_DEFAULT: SIZE_MEDIUM,
  SIZE_COMPONENT_NAME_MAPPING: Object.fromEntries(
    new Map(
      [
        [SIZE_SMALL, CCLoaderCircleSmall],
        [SIZE_MEDIUM, CCLoaderCircleMedium],
        [SIZE_LARGE, CCLoaderCircleLarge],
        [SIZE_EXTRALARGE, CCLoaderCircleExtraLarge]
      ]
    )
  ),
  PROCESSING_TITLE_DEFAULT: appConstants.LABEL_PROCESSING_IN_PROGRESS
});

const propsDefaults = Object.freeze({
  size: constants.SIZE_DEFAULT,
  title: constants.PROCESSING_TITLE_DEFAULT
});

function getValidSize(propsSize) {
  return getValidProp(propsSize, 'size', constants.SIZE_DEFAULT, constants.SIZES, constants.COMPONENT_NAME , appConstants.APP_DEBUG_LOGGER);
}

export default function ProcessingIndicator({
  size = propsDefaults.size,
  title = propsDefaults.title,
  className = ''
}) {
  const validSize = getValidSize(size);
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const IconComponent = constants.SIZE_COMPONENT_NAME_MAPPING[validSize];
  return (
    <span className={computedClassName} title={title} aria-label={title}>
      <span className="sr-only">{title}</span>
      <IconComponent aria-hidden="true" className="animate-spin !inline"/>
    </span>
  );
}
